import { render } from "./EiProfileGrowthComparisonBlock.vue?vue&type=template&id=c54dc07e&scoped=true"
import script from "./EiProfileGrowthComparisonBlock.vue?vue&type=script&lang=js"
export * from "./EiProfileGrowthComparisonBlock.vue?vue&type=script&lang=js"

import "./EiProfileGrowthComparisonBlock.vue?vue&type=style&index=0&id=c54dc07e&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54dc07e"]])

export default __exports__